export default __webpack_public_path__ + "static/media/593.1de2071b.jpg";